<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="isSmallScreen ? '30px' : '20px'" :height="isSmallScreen ? '30px' : '20px'" viewBox="0 0 24 24" fill="none" stroke="#747272" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-copy-icon lucide-copy">
    <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/>
    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>
  </svg>
</template>
<script lang="ts">
import {useScreenSize} from "@/composable/useScreenSize.js";
export default {
  name: 'IconCopy',
  setup() {
    const { width, isSmallScreen } = useScreenSize(1024);
    return {
      width,
      isSmallScreen,
    }
  }
}
</script>